// src/datasource/DataSourceIcon.tsx
import * as React from "react";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import HttpIcon from "@mui/icons-material/Http";
import StorageIcon from "@mui/icons-material/Storage";
import { SvgIconProps } from "@mui/material";

export default function DataSourceIcon({
  type,
  ...props
}: { type: string } & SvgIconProps) {
  if (type === "CSV") return <InsertDriveFileIcon {...props} />;
  if (type === "API") return <HttpIcon {...props} />;
  return <StorageIcon {...props} />;
}
